import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';

import FieldTreeResultService from '../../services/fieldTreeResult/FieldTreeResultService.js';

import { DateSelectorPanel } from '../DateSelectorPanel';
import { SearchMenuHeader } from './SearchMenuHeader';

import Styles from '../../styles/componentStyle/fieldTreeResult/fieldTreeResult.scss';

import { DATE_TIME_FORMAT } from '../../utilities/constants';

/**
 * 入場人数との差異検索フォーム
 */
export class SearchForm extends React.Component {
  constructor(props) {
    super(props);

    const today = Moment().format(DATE_TIME_FORMAT.slashDateFormat);
    this.state = {
      isDateSelectorActive: false,
      displayFilter: 0, // 0: 個社・合計, 1: 個社, 2: 合計
      fromDate: today, // 期間開始日
      toDate: today, // 期間終了日
      isUnfulfillRate: 0, // 未充足の協力会社のみ (0: 全て, 1: 未充足の協力会社のみ)
      isToggleOpened: false, // 検索フォームトグルの開閉フラグ
    };
    this.notifySearchParamsChanged();

    this.nodeRef = React.createRef();
    document.addEventListener('mousedown', this.handleDocumentClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentClick, false);
  }

  notifySearchParamsChanged = () => {
    this.props.searchParamsChanged({
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      isUnfulfillRate: this.state.isUnfulfillRate,
    });
  };

  notifyFilterParamsChanged = () => {
    this.props.filterParamsChanged({
      displayIndividual:
        this.state.displayFilter == 0 || this.state.displayFilter == 1,
      displayTotal:
        this.state.displayFilter == 0 || this.state.displayFilter == 2,
    });
  };

  toggleOpened = () => {
    this.setState(prevState => ({
      isToggleOpened: !prevState.isToggleOpened,
    }));
  };

  toggleDateSelector = () => {
    this.setState(prevState => ({
      isDateSelectorActive: !prevState.isDateSelectorActive,
    }));
  };

  handleClickOutside = () => {
    this.setState({ isDateSelectorActive: false });
  };

  handleDocumentClick = e => {
    if (this.nodeRef.current.contains(e.target)) {
      return;
    }

    this.handleClickOutside();
  };

  handleDateRangeChange = ({ fromDate, toDate }) => {
    this.setState({ fromDate, toDate, isDateSelectorActive: false }, () => {
      this.notifySearchParamsChanged();
    });
  };

  handleDisplayFilterChange = e => {
    this.setState({ displayFilter: parseInt(e.target.value) }, () => {
      this.notifyFilterParamsChanged();
    });
  };

  handleIsUnfulfillRateChange = e => {
    this.setState({ isUnfulfillRate: e.target.checked ? 1 : 0 }, () => {
      this.notifySearchParamsChanged();
    });
  };

  clearSearchConditions = () => {
    this.setState({ isUnfulfillRate: 0 }, () => {
      this.notifySearchParamsChanged();
    });
  };

  /**
   * 日付情報を出力する
   * @param fromDate 期間開始
   * @param toDate   期間終了
   */
  dateRangeText(fromDate, toDate) {
    const inputFormat = DATE_TIME_FORMAT.slashDateFormat;
    const displayFormat = DATE_TIME_FORMAT.weekdaySlashDateFormat;
    const fromDisplayDate = Moment(fromDate, inputFormat).format(displayFormat);
    const toDisplayDate = Moment(toDate, inputFormat).format(displayFormat);
    if (fromDate === toDate) {
      return fromDisplayDate;
    } else {
      return `${fromDisplayDate} 〜 ${toDisplayDate}`;
    }
  }

  renderHeader = () => {
    const fieldTreeResultData = this.props.fieldTreeResultData;
    if (fieldTreeResultData == null) {
      return;
    }

    return (
      <table className='header'>
        <tbody>
          <tr>
            <td>{data.header.summary}</td>
            <td>{data.header.planned}</td>
            <td>
              {FieldTreeResultService.buildCellString(
                fieldTreeResultData.work_schedule_daywork_grand_total,
                fieldTreeResultData.work_schedule_grand_total
              ) || data.header.default_cell_value}
            </td>
          </tr>
          <tr>
            <td />
            <td>{data.header.actual}</td>
            <td>
              {FieldTreeResultService.buildCellString(
                fieldTreeResultData.work_result_daywork_grand_total,
                fieldTreeResultData.work_result_grand_total
              ) || data.header.default_cell_value}
            </td>
          </tr>
          <tr>
            <td />
            <td>{data.header.in_out_days}</td>
            <td>
              {fieldTreeResultData.in_out_days_grand_total ||
                data.header.default_in_out_days}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  renderDateRange() {
    return (
      <div className='form-element'>
        <div className='form-element__label'>{data.searchTitle.date}</div>
        <div className='date-dropdown-list date-selector' ref={this.nodeRef}>
          <button className='date-btn-header' onClick={this.toggleDateSelector}>
            <div className='date-btn-header__date'>
              <span className='date-btn-header__txt'>
                {this.dateRangeText(this.state.fromDate, this.state.toDate)}
              </span>
            </div>
            <i className='i-arrow-bottom--light i-3x' aria-hidden='true' />
          </button>
          <DateSelectorPanel
            show={this.state.isDateSelectorActive}
            fromDate={this.state.fromDate}
            toDate={this.state.toDate}
            onChangeSearchDateRange={this.handleDateRangeChange}
            showNextButtons={false}
          />
        </div>
      </div>
    );
  }

  renderRadioButtons() {
    return (
      <div className='form-element'>
        <div className='element__item'>
          <label htmlFor='radio0' className='radio'>
            <input
              id='radio0'
              type='radio'
              name='radio_'
              value={0}
              checked={this.state.displayFilter === 0}
              onChange={this.handleDisplayFilterChange}
            />
            <i className='i-2x' />
            <span>{data.radio.both}</span>
          </label>
        </div>
        <div className='element__item'>
          <label htmlFor='radio1' className='radio'>
            <input
              id='radio1'
              type='radio'
              name='radio_'
              value={1}
              checked={this.state.displayFilter === 1}
              onChange={this.handleDisplayFilterChange}
            />
            <i className='i-2x' />
            <span>{data.radio.individual}</span>
          </label>
        </div>
        <div className='element__item'>
          <label htmlFor='radio2' className='radio'>
            <input
              id='radio2'
              type='radio'
              name='radio_'
              value={2}
              checked={this.state.displayFilter === 2}
              onChange={this.handleDisplayFilterChange}
            />
            <i className='i-2x' />
            <span>{data.radio.total}</span>
          </label>
        </div>
      </div>
    );
  }

  renderSearchConditions() {
    return (
      <div
        id='search-form-accordion'
        className={`searchForm accordion ${
          this.state.isToggleOpened ? 'show' : ''
        }`}
      >
        <div className='search-form__body'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              <div className='search-form-element'>
                <label className='checkbox'>
                  <input
                    type='checkbox'
                    checked={this.state.isUnfulfillRate === 1}
                    onChange={this.handleIsUnfulfillRateChange}
                  />
                  <i className='i-square i-3x' aria-hidden='true' />
                  {data.searchTitle.checkbox}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={`${Styles.search} flex-container`}>
        <div>
          <div className='search-form'>
            <div className='form'>
              <div className='form__group'>
                {this.renderDateRange()}
                {this.renderRadioButtons()}
              </div>
            </div>
            <SearchMenuHeader
              total={this.props.resultsTotal}
              isOpened={this.state.isToggleOpened}
              searchFormHandle={this.toggleOpened}
              clearSearchProperty={this.clearSearchConditions}
            />
            {this.renderSearchConditions()}
          </div>
        </div>
        <div>{this.renderHeader()}</div>
      </div>
    );
  }
}

SearchForm.propTypes = {
  fieldTreeResultData: PropTypes.shape({
    work_schedule_daywork_grand_total: PropTypes.string,
    work_schedule_grand_total: PropTypes.string,
    work_result_daywork_grand_total: PropTypes.string,
    work_result_grand_total: PropTypes.string,
    in_out_days_grand_total: PropTypes.string,
  }),
  resultsTotal: PropTypes.number,
  searchParamsChanged: PropTypes.func,
  filterParamsChanged: PropTypes.func,
};

// 定数
const data = {
  clearButtonTitle: '検索条件クリア',
  radio: {
    both: '個社・合計の値を表示',
    individual: '個社の値を表示',
    total: '合計の値を表示',
  },
  header: {
    summary: '表示データ合計',
    planned: '作業予定(常傭/請負)',
    actual: '作業実績(常傭/請負)',
    in_out_days: '入退場実績',
    default_in_out_days: '0.0',
    default_cell_value: '0.0 (0.0 / 0.0)',
  },
  searchTitle: {
    date: '集計期間',
    checkbox: '未充足の協力会社のみを表示',
  },
};



// WEBPACK FOOTER //
// ./src/components/searchmenus/FieldTreeResultSearch.jsx